require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-hoj-return-to-rio.json") })
        }
      }, "path---interview-hoj-return-to-rio");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-hoj-return-to-rio!./.cache/json/interview-hoj-return-to-rio.json
// module id = 678
// module chunks = 231608221292675